// @flow

import Resource from '../api/Resource';

export default class LiveResource extends Resource {
}
